"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableOptions = void 0;
var availableOptions = ['viewMode', 'dragMode', 'initialAspectRatio', 'aspectRatio', 'data', 'preview', 'responsive', 'restore', 'checkCrossOrigin', 'checkOrientation', 'modal', 'guides', 'center', 'highlight', 'background', 'autoCrop', 'autoCropArea', 'movable', 'rotatable', 'scalable', 'zoomable', 'zoomOnTouch', 'zoomOnWheel', 'wheelZoomRatio', 'cropBoxMovable', 'cropBoxResizable', 'toggleDragModeOnDblclick', 'minContainerWidth', 'minContainerHeight', 'minCanvasWidth', 'minCanvasHeight', 'minCropBoxWidth', 'minCropBoxHeight',
// event shortcut functions
'ready', 'cropstart', 'cropmove', 'crop', 'zoom'];
exports.availableOptions = availableOptions;